/**
 * ADA (Accessibility) global fixes for third-party integrations.
 */
function fixPandectesCloseButtonLabel() {
  if (!window.PandectesSettings) return

  const CLOSE_BUTTON_SELECTOR = '.cc-close'
  const ARIA_LABEL = 'Close'

  let executed = false

  const observer = new MutationObserver(() => {
    if (executed) return

    const closeButton = document.querySelector<HTMLButtonElement>(CLOSE_BUTTON_SELECTOR)

    if (closeButton) {
      closeButton.setAttribute('aria-label', ARIA_LABEL)
      executed = true
      observer.disconnect()
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

const enableKeyboardFocusOutlines = () => {
  const root = document.documentElement

  const handleKeyDown = (event: KeyboardEvent) => {
    if (
      event.key === 'Tab' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight'
    ) {
      root.classList.add('user-is-tabbing')
    }
  }

  const handleMouseDown = () => {
    root.classList.remove('user-is-tabbing')
  }

  window.addEventListener('keydown', handleKeyDown)
  window.addEventListener('mousedown', handleMouseDown)
}

enableKeyboardFocusOutlines()
fixPandectesCloseButtonLabel()
